var _rect, _circle, _path, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewIconSmileOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#FDBD38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12C7.22386 12 6.99737 12.2245 7.02462 12.4993C7.27516 15.0263 9.40709 17 12 17C14.5929 17 16.7248 15.0263 16.9754 12.4993C17.0026 12.2245 16.7761 12 16.5 12C16.2239 12 16.0033 12.225 15.9692 12.499C15.7236 14.4726 14.0402 16 12 16C9.95985 16 8.27643 14.4726 8.03082 12.499C7.99672 12.225 7.77614 12 7.5 12Z",
    fill: "#505768"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1,
    fill: "#505768"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 1,
    fill: "#505768"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIconSmileOn);
export default __webpack_public_path__ + "static/media/view_icon_smile_on.b1748c3c0812c1d8001a3c7cf2296c15.svg";
export { ForwardRef as ReactComponent };